import React from 'react'
import { useCallback, useEffect } from 'react'
import InputField from '../form/InputField'
import FormWrapper from '../form/FormWrapper'
import { memo } from 'react'
import CategoryImage from '../CategoryImage'
import { uniformUrl } from '../../helpers/StringHelpers'
import { ProductTypeHelper } from '../../helpers/ProductTypeHelper'
import useFormState from '../form/hooks/useFormState'
import PropTypes from 'prop-types'
import isEmail from '../form/validators/isEmail'
import { useDispatch } from 'react-redux'
import { hideChat, unhideChat } from '../../state/popupForms'
import isPhone from '../form/validators/isPhone'

const IconHeartSvg = ({ className }) => {
  return (
    <svg
      className={'icon icon-heart fill-current ' + className}
      version="1.1"
      viewBox="-2 -2 36 36"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="https://www.w3.org/1999/xlink"
      aria-label="Favorite"
    >
      <path d="M23.6 2c-3.363 0-6.258 2.736-7.599 5.594-1.342-2.858-4.237-5.594-7.601-5.594-4.637 0-8.4 3.764-8.4 8.401 0 9.433 9.516 11.906 16.001 21.232 6.13-9.268 15.999-12.1 15.999-21.232 0-4.637-3.763-8.401-8.4-8.401z"></path>
    </svg>
  )
}
IconHeartSvg.propTypes = {
  className: PropTypes.string,
}
export const IconHeart = memo(IconHeartSvg)

const FavoriteItems = ({ product, setFavorite }) => {
  const dispatch = useDispatch()
  const url = uniformUrl(product.url + '/')
  const onClosePopup = useCallback(e => {
    if (e && e.preventDefault) e.preventDefault()
    if (setFavorite) setFavorite(null)
    dispatch(unhideChat())
  }, [])

  const handleKeyPress = e => {
    switch (e.key) {
      case 'Escape':
        if (setFavorite) setFavorite(null)
        break
      default:
        break
    }
  }
  React.useEffect(() => {
    if (typeof window === 'undefined') return
    window.addEventListener('keydown', handleKeyPress)
    return () => {
      window.removeEventListener('keydown', handleKeyPress)
    }
  }, [setFavorite])
  const [form, setForm, updateForm] = useFormState({
    name: '',
    email: '',
    phone: '',
    sku: '',
    product: '',
    consent: true,
  })

  useEffect(() => {
    if (product) {
      setForm(f => ({ ...f, product: product.name, sku: product.sku }))
      dispatch(hideChat())
    }
  }, [product])
  const onChangeHandler = e => {
    setForm(f => ({ ...f, [e.target.name]: e.target.checked }))
  }
  return (
    <div className="fade-in-now fixed top-0 left-0 flex h-full w-full items-center justify-center lg:h-screen z-popup bg-white md:bg-transparent backdrop-blur-sm">
      <button
        className="inset-0 cursor-alias absolute bg-slate-400 opacity-40"
        onClick={onClosePopup}
      />

      <div className="fade-in-favorite absolute top-[50%] left-[50%] flex w-full -translate-y-[50%] -translate-x-[50%] flex-col md:flex-row gap-3 rounded-xl bg-white p-5 md:shadow-md shorter768:h-screen shorter768:w-screen md:w-max justify-center items-center ">
        <div className="aspect-square object-contain flex justify-center items-center max-w-[300px]">
          <CategoryImage
            sku={product.sku}
            alt={product.name}
            title={product.title}
            normal={product.small_image}
            url={url}
            productType={product.productType || ProductTypeHelper(product)}
            tags={false}
            imgStyle={{ objectFit: 'contain' }}
            product={product}
            className={'w-full h-full aspect-square'}
          />
        </div>
        <div className="col-span-2 flex flex-col justify-center  sm:col-span-1 max-w-[400px] ">
          <div className="mx-auto flex max-w-max flex-row flex-wrap items-center justify-center  pr-4 text-center text-4xl font-black text-red-700 sm:text-3xl">
            <IconHeart className=" relative mx-3 h-10 w-10 animate-pulse " />
            NOTIFY ME
          </div>
          <p className="mx-auto my-2 w-10/12 text-center text-gray-700">
            Enter your information and we will notify you with similar items or price changes.
          </p>
          <FormWrapper
            form={form}
            name={'Favorite Item Alerts'}
            action={onClosePopup}
            method={'POST'}
            className="flex flex-col"
          >
            <InputField
              errorMessage=""
              name={'name'}
              label={'Name'}
              form={form}
              onChange={updateForm}
              required={true}
            />
            <InputField
              errorMessage=""
              name={'email'}
              label={'E-Mail'}
              form={form}
              validator={isEmail}
              onChange={updateForm}
              className={'w-full'}
              required={true}
            />
            <InputField
              errorMessage=""
              name={'phone'}
              label={'Phone'}
              form={form}
              validator={isPhone}
              onChange={updateForm}
              className={'w-full'}
              required={true}
            />
            <label className="text-xs text-gray-500 flex flex-row gap-3 items-start my-2">
              <input
                type="checkbox"
                name="consent"
                checked={form['consent']}
                onChange={onChangeHandler}
              />
              I agree to receive updates and follow-up messages about my inquiries via text and
              email.
            </label>
            <div className="mt-4 grid grid-cols-2 gap-3">
              <button
                onClick={onClosePopup}
                className="w-full rounded-lg border-2 border-gray-400 py-2 text-gray-400"
              >
                CANCEL
              </button>

              <button className="rounded-lg bg-red-600 px-8 py-2 font-bold text-white hover:bg-red-800">
                SUBSCRIBE
              </button>
            </div>
          </FormWrapper>
        </div>
      </div>
    </div>
  )
}
FavoriteItems.propTypes = {
  product: PropTypes.object,
  setFavorite: PropTypes.func,
}

export default FavoriteItems
